export default __webpack_public_path__ + "static/media/elements-gestalt.0dbfd7cb.svg";